export function commonStateUpdates(state, action) {
  const events = action.payload.events || [];
  const processingItems = events.filter((e) => e.status === 'Processing');

  // find total items on the basis of all events if all of them are completed, else only on processing items
  const relavantItems = processingItems.length ? processingItems : events;

  const itemsProcessed = relavantItems.reduce((acc, event) => acc + event.itemsProcessed, 0);
  const totalItems = relavantItems.reduce((acc, event) => acc + event.totalItems, 0);

  state.processingEventsCount = processingItems.length;
  state.isImportInProgress = processingItems.length > 0;

  state.itemsProcessed = itemsProcessed || 0;
  state.totalItems = totalItems || 0;
  state.type = events.length > 0 ? events[0].type : '';

  const [lastProcessedTime] = events
    .map((event) => event.finished)
    .sort((a, b) => new Date(b) - new Date(a));
  state.lastProcessedTime = lastProcessedTime;
}
